import { Link } from "react-router-dom";
import { format } from "date-fns";
import VinylRecord from "@/components/VinylRecord";

export default function EpisodeCard({ episode }) {
  const date = episode.published_at
    ? format(new Date(episode.published_at), "MMM d, yyyy")
    : "";
  return (
    <Link
      to={`/episodes/${episode.slug}`}
      data-testid={`episode-card-${episode.slug}`}
      className="group block rounded-2xl border border-corduroy bg-cocoa p-6 transition-transform duration-300 hover:-translate-y-1"
    >
      <div className="flex items-start justify-between gap-4">
        {episode.thumbnail_url ? <img data-testid={`episode-card-image-${episode.slug}`} src={episode.thumbnail_url} alt={episode.thumbnail_alt || ""} className="h-[72px] w-[72px] rounded-lg object-cover" /> : <VinylRecord size={72} spin={false} label={episode.episode_number ? `PRG ${episode.episode_number}` : "TWSS"} />}
        <span className="text-xs font-semibold uppercase tracking-[0.2em] text-latte">
          {date}
        </span>
      </div>
      <h3 className="mt-6 font-display text-xl font-bold leading-snug text-cream transition-colors group-hover:text-gold md:text-2xl">
        {episode.title}
      </h3>
      {episode.subtitle && <p className="mt-2 text-sm leading-relaxed text-latte">{episode.subtitle}</p>}
      {episode.topics?.length > 0 && (
        <div className="mt-4 flex flex-wrap gap-2">
          {episode.topics.slice(0, 3).map((t) => (
            <span
              key={t}
              className="rounded-full border border-corduroy px-3 py-1 text-xs text-latte"
            >
              {t}
            </span>
          ))}
        </div>
      )}
    </Link>
  );
}
